'use client';

import { type ReactNode, createContext, useRef } from 'react';
import { createStore } from './createStore.ts';
import { type State } from './types.ts';

export type StoreApi = ReturnType<typeof createStore>;

export type StoreProviderProps = {
  children: ReactNode;
  initialState?: Partial<State>;
};

export const StoreContext = createContext<StoreApi | undefined>(undefined);

export const StoreProvider = ({ children, initialState }: StoreProviderProps) => {
  const storeRef = useRef<StoreApi>(undefined);
  storeRef.current ??= createStore(initialState);
  return <StoreContext.Provider value={storeRef.current}>{children}</StoreContext.Provider>;
};
